/* Keep WhatsApp/Instagram floating contact buttons on home and collection pages, hide them on product detail pages only. */
(function () {
  'use strict';
  function isProductPage() {
    return document.body.classList.contains('template-product') || /\/products\//.test(window.location.pathname);
  }
  var socialPattern = /wa\.me|whatsapp|api\.whatsapp|instagram\.com|instagr\.am/i;
  function hideFloatingSocialWidgets() {
    if (!isProductPage()) return;
    var links = document.querySelectorAll('a[href], iframe[src]');
    links.forEach(function (link) {
      var target = link.getAttribute('href') || link.getAttribute('src') || '';
      var label = (link.getAttribute('aria-label') || '') + ' ' +
        (link.getAttribute('title') || '') + ' ' + (link.textContent || '');
      if (!socialPattern.test(target) && !/whatsapp|instagram/i.test(label)) return;
      var node = link;
      for (var depth = 0; node && node !== document.body && depth < 10; depth++, node = node.parentElement) {
        var style = window.getComputedStyle(node);
        var rect = node.getBoundingClientRect();
        var nearFloatingCorner = rect.width > 0 && rect.height > 0 &&
          rect.right > window.innerWidth - 260 && rect.bottom > window.innerHeight - 360;
        if ((style.position === 'fixed' || style.position === 'sticky') && nearFloatingCorner) {
          node.style.setProperty('display', 'none', 'important');
          node.setAttribute('data-izabell-hidden-social-product', 'true');
          break;
        }
      }
    });
  }
  hideFloatingSocialWidgets();
  var observer = new MutationObserver(hideFloatingSocialWidgets);
  function startObserver() {
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hideFloatingSocialWidgets();
      startObserver();
    }, { once: true });
  } else {
    startObserver();
  }
  window.addEventListener('load', hideFloatingSocialWidgets, { once: true });
  window.addEventListener('resize', hideFloatingSocialWidgets);
})();
 
/* izabell-bottom-cart-opens-header-drawer-v1: make the fixed mobile Cart open the same drawer as the header Cart. */
(function () {
  if (window.__izabellBottomCartDrawerV1) return;
  window.__izabellBottomCartDrawerV1 = true;
  function openHeaderCart() {
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (!trigger) return false;
    trigger.click();
    return true;
  }
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest
      ? event.target.closest('.izabell-bottom-nav a[aria-label="Cart"]')
      : null;
    if (!link) return;
    event.preventDefault();
    if (document.querySelector('#cart-drawer cart-drawer-component')) {
      openHeaderCart();
      return;
    }
    var target = new URL('/', window.location.origin);
    target.searchParams.set('izabellOpenCart', '1');
    window.location.assign(target.toString());
  });
  function openCartFromQuery() {
    var url = new URL(window.location.href);
    if (url.searchParams.get('izabellOpenCart') !== '1') return;
    url.searchParams.delete('izabellOpenCart');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (openHeaderCart() || attempts >= 20) window.clearInterval(timer);
    }, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openCartFromQuery, { once: true });
  } else {
    openCartFromQuery();
  }
})();

/* izabell-mobile-bottom-cart-restore-v1 */
/* Restore the mobile bottom Cart tab in this draft only. */
(function () {
  if (window.__izabellMobileBottomCartRestoreV1) return;
  window.__izabellMobileBottomCartRestoreV1 = true;
  function restoreCartTab() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.izabell-bottom-nav a[aria-label="Cart"]').forEach(function (link) {
      link.style.setProperty('display', 'flex', 'important');
      link.style.setProperty('visibility', 'visible', 'important');
      link.style.setProperty('opacity', '1', 'important');
      link.style.setProperty('pointer-events', 'auto', 'important');
      link.removeAttribute('aria-hidden');
      link.removeAttribute('tabindex');
    });
  }
  function start() {
    restoreCartTab();
    if (document.body) new MutationObserver(restoreCartTab).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style','class','aria-hidden','tabindex']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  window.addEventListener('resize', restoreCartTab);
})();
